import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { SelectedGoalParams } from '@/features/LK/GoalModal';
import { ConsultationParams, GlobalStore } from '../types/store';

export const useGlobalStore = create<GlobalStore>()(
    devtools((set) => ({
        isConsultationAllowed: true,
        setIsConsultationAllowed: (isConsultationAllowed) => set({ isConsultationAllowed }),

        isRegistrationAllowed: false,
        setIsRegistrationAllowed: (isRegistrationAllowed) => set({ isRegistrationAllowed }),

        consultationParams: {} as ConsultationParams,
        setConsultationParams: (consultationParams) => set({ consultationParams }),

        selectedGoalParams: {} as SelectedGoalParams,
        setSelectedGoalParams: (selectedGoalParams) => set({ selectedGoalParams }),

        VI: false,
        setVI: (VI) => set({ VI }),
    }))
);
